import React, { FC, PropsWithChildren, useMemo } from 'react'
import { AnimatePresence } from 'framer-motion'
import S from './styles'

const AlertStack: FC<PropsWithChildren> = ({ children }) => {
  const items = React.Children.toArray(children)
  const show = useMemo(() => items.length > 0, [items])

  return (
    <AnimatePresence mode="popLayout">
      {show && (
        <S.AlertStack initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
          {children}
        </S.AlertStack>
      )}
    </AnimatePresence>
  )
}

export default AlertStack
